window.addEventListener('DOMContentLoaded', () => {
  initContactForm();
  initContactFormSubmissionEnabled();
  initContactFormOtherDropdownField();
  initFormFieldCounters();
});

export function initContactForm() {
  const be_form = document.querySelectorAll('.neos-backend .c-contact-form button');
  if (be_form) {
    be_form.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
      });
    });
  }
  window.addEventListener('UC_UI_INITIALIZED', () => {
    const captchaCookie = checkCaptchaCookieStatus();
    setByCookieStatus(captchaCookie);
    if (captchaCookie) initShadowRootCookieNoticeButtons();
  });

  // Scroll to contact the form after submitting
  window.addEventListener('submit', function (e) {
    const form = e.target;
    const formContainer = form.closest('.c-contact-form');

    if (form && formContainer && formContainer.id) {
      const currentAction = form.action || window.location.href;
      const url = new URL(currentAction);
      url.hash = formContainer.id;
      form.action = url.toString();
    }
  });
}

function checkCaptchaCookieStatus() {
  if (!window.UC_UI) return false;

  return window.UC_UI.getServicesBaseInfo().find((service) => service.name === 'reCaptcha v3').consent.status === true;
}

function initShadowRootCookieNoticeButtons() {
  window.addEventListener('UC_UI_CMP_EVENT', function (e) {
    const types = ['ACCEPT_ALL', 'DENY_ALL', 'SAVE'];
    if (e.detail && types.includes(e.detail.type)) {
      setByCookieStatus(checkCaptchaCookieStatus());
    }
  });
}

function setByCookieStatus(active = false) {
  const form = document.querySelector('.c-contact-form');
  const warning = form?.querySelector('.form-warning');
  const sendButton = form?.querySelector('button[type="submit"]');
  const acceptButton = form?.querySelector('.accept-captcha-cookie');

  warning?.classList?.toggle('hidden', active);
  if (sendButton) sendButton.disabled = !active;

  if (!active) {
    acceptButton?.addEventListener('click', acceptCaptchaCookie);
  } else {
    acceptButton?.removeEventListener('click', acceptCaptchaCookie);
  }
}

function acceptCaptchaCookie() {
  window.UC_UI?.acceptService('cfADcn3E3')?.then(() => setByCookieStatus(true));
}

function initContactFormSubmissionEnabled() {
  const form = document.querySelector('.c-contact-form');
  const sendButton = form?.querySelector('button[type="submit"]');
  const requiredFormFields = form?.querySelectorAll('input[required], textarea[required], select[required]');

  if (!form || !sendButton || requiredFormFields.length === 0) return;

  // Validate form state
  const validateForm = () => {
    const allFieldsFilled = Array.from(requiredFormFields).every((field) => field.value.trim() !== '');
    sendButton.disabled = !allFieldsFilled;
  };

  // Initial state
  validateForm();

  // Listen to all required fields
  requiredFormFields.forEach((field) => {
    field.addEventListener('input', validateForm);
    field.addEventListener('change', validateForm);
  });
}

function initContactFormOtherDropdownField() {
  const form = document.querySelector('.c-contact-form');
  const otherOption = form?.querySelector('option[value="other"]');

  if (!otherOption) return;
  const dropdown = otherOption.closest('select');
  const otherField = dropdown.parentElement.querySelector('.c-field-container.hidden');
  dropdown.addEventListener('change', function () {
    if (this.value === 'other') {
      otherField.classList.remove('hidden');
      dropdown.parentElement.classList.add('dropdown-other');
    } else {
      otherField.classList.add('hidden');
      dropdown.parentElement.classList.remove('dropdown-other');
    }
  });
}

function initFormFieldCounters() {
  const form = document.querySelector('.c-contact-form');
  form?.querySelectorAll('input, textarea').forEach((field) => {
    const maxLength = Number.parseInt(field.getAttribute('maxlength'));
    if (!maxLength) return;

    const counter = document.createElement('span');
    counter.classList.add('counter');

    const updateCounter = () => {
      const currentLength = Number.parseInt(field.value.length);
      counter.textContent = `${currentLength}/${maxLength}`;
      counter.classList.toggle('max-length', currentLength === maxLength);
    };

    updateCounter();
    field.parentNode.appendChild(counter);
    field.addEventListener('input', updateCounter);
  });
}
